import axios from "axios";

/** Lean active memberships for a user (id, name, organization_user_id). */
export async function fetchUserOrganizations(userId) {
  const { data } = await axios.post(
    `/users/${userId}/retrieve-organizations/`,
    {}
  );
  return data.response[0]?.data || [];
}
